module Meevo.Plugins.ServicesWizard {
  
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import VerbEnum = Meevo.Model.VerbEnum;
    import NounEnum = Meevo.Model.NounEnum;
    import TrackingItem = Meevo.Model.TrackingItem;
 
    import any = jasmine.any;


    export interface IServicesWizardCriteria {
        objectStateEnum?: ObjectStateEnum;
        cat_SId?: number;
        user_TId?: Guid;
    }

    export interface IServicesWizardService {
        serviceList: Array<any>;
        serviceCatList: Array<any>;
        
        selectedServiceList: Array<any>;
        selectedServiceCatList: Array<any>;



        getServiceCategoryList: () => ng.IPromise<any>;
        getServicesList: ()=> ng.IPromise<any>;
        importServicesData: () => ng.IPromise<any>;
        usageTrackingLog: (nounEnum: NounEnum, verbEnum: VerbEnum) => void;
        getSecurityManagerKeys: (id: number) => ng.IPromise<any>;
      
    }

    export class ServicesWizardService implements IServicesWizardService {

        private _serviceList: Array<any> = [];
        private _serviceCatList: Array<any> = [];

        private _selectedServiceList: Array<Model.DataDetail> = [];
        private _selectedServiceCatList: Array<Model.DataDetail> = [];



        static $inject = [
            'meevo.components.common.DataService',
            'meevo.AppSettings',
            'meevo.components.tracking.TrackingService'
        ];

        constructor(
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected trackingService: Meevo.Components.Tracking.ITrackingService
        ) {
        }

        /**
         * Get list of Alert User(IAlertUserListItem) or Alert Category(IAlertCatListItem)
         * @param {DisplayViewsEnum} view
         * @param {IAlertCriteria} criteria
         */
        getServiceCategoryList(): ng.IPromise<any> {
            var crt = { objectStateEnum: ObjectStateEnum.Active };
            return this.getAllServiceCategoryList(crt);
        }

        /**
         * 
         */
        getServicesList(): ng.IPromise<any> {
            var requestData: any;
            var serviceCatList: IServicesListGet;

            if (this.selectedServiceCatList.length == 0)
                return;

            serviceCatList = { serviceCats: this.selectedServiceCatList };
            
            return this.dataService.customMethodData(`${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.servicesWizard}/ServicesList`,
                'POST', serviceCatList).then(response => this.serviceList = response.data);
        }


        
        /**
       * 
       */
        importServicesData(): ng.IPromise<any> {
            var requestData: any;
            var importServices: any;
            
            importServices = { importServicesList: this.selectedServiceList }
           
            var result= this.dataService.customMethodData(`${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.servicesWizard}/ImportServices`,
                'POST', importServices).then(response => this.serviceList = response.data);
            this.selectedServiceList = null;
            this.selectedServiceCatList = null;
            return result;
        }


        /**
         * 
         */
        getAllServiceCategoryList(criteria?: IServicesWizardCriteria): ng.IPromise<any[]> {
            return this.dataService
                .customMethodData(`${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.servicesWizard}`,
                    'GET',
                "").then(response => this.serviceCatList = response.data); 
        }




        /**
         * Track user activity
         * @param {NounEnum} nounEnum
         * @param {VerbEnum} verbEnum
         */
        usageTrackingLog(nounEnum: NounEnum, verbEnum: VerbEnum): void {
            let trackingItem = new TrackingItem(nounEnum, verbEnum, null);

            this.trackingService.saveTrackingInfo(trackingItem);
        }

        /**
         * Get security keys by feature id
         * @param {number} id
         */
        getSecurityManagerKeys(id: number): ng.IPromise<any> {
            return this.dataService.customMethodData('api/SecurityManager',
                'POST',
                {
                    allModules: false,
                    allRoles: false,
                    isForCOUseOnly: false,
                    moduleKeys: [id]
                }).then(response => response.data);
        }


        get serviceList(): Array<any> {
            return this._serviceList;
        }

        set serviceList(list: Array<any>) {
            this._serviceList = list;
        }
        
        get serviceCatList(): Array<any> {
            return this._serviceCatList;
        }
        set serviceCatList(list: Array<any>) {
            this._serviceCatList = list;
        }

        get selectedServiceList(): Array<any> {
            return this._selectedServiceList ;
        }

        set selectedServiceList(list: Array<any>) {
            this._selectedServiceList = list;
        }
        get selectedServiceCatList(): Array<Meevo.Model.DataDetail> {
            return this._selectedServiceCatList;
        }

        set selectedServiceCatList(list: Array<Meevo.Model.DataDetail>) {
            this._selectedServiceCatList = list;
        }

    }

    angular.module('meevo.plugins.servicesWizard')
        .service('meevo.plugins.servicesWizard.ServicesWizardService', Meevo.Plugins.ServicesWizard.ServicesWizardService);
}